import { Component, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";
import { withFormik, Form } from "formik";

import { ZonesTable } from "../FarmInfo/Tables";
import { switchTipoHidraulica } from "../Hydraulic/Hydraulic";

import { FarmContext } from "../../contexts/FarmContext";
import { useColsEffect, useGridRef } from "../../utils/tables";

import SelfHelp from "../Utils/SelfHelp";
import LoadingDialog from "../Utils/LoadingDialog";
import { callSend, FormRow, TimeRow, HeaderButtons } from "../Form/Form";
import { GoogleMapsFarm } from "../GoogleMapsFarm/GoogleMapsFarm";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "react-toastify/dist/ReactToastify.css";
import getBaseLangs from "../../utils/language";
import withName from "../../hoc/withName";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
const pump = "pump_form";

const getPump = (location) => {
    if (location.search.search("pumpsys") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const pump = params.get("pumpsys");
        return pump;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

class PumpForm extends Component {
    render() {
        const { resetForm, status = {}, canEdit, hasCorteAlarm, setStatus, data, values, t, i18n, handleSubmit } = this.props;
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12">No Data</div>;
        const isEdit = canEdit && status.edit;
        let inicio_hora_punta = data.inicio_hora_punta;
        if (inicio_hora_punta) {
            const lastIndexInicio = inicio_hora_punta.lastIndexOf(":");
            if (lastIndexInicio > 0) {
                inicio_hora_punta = inicio_hora_punta.substring(0, lastIndexInicio);
            }
        }
        let fin_hora_punta = data.fin_hora_punta;
        if (fin_hora_punta) {
            const lastIndexFin = fin_hora_punta.lastIndexOf(":");
            if (lastIndexFin > 0) {
                fin_hora_punta = fin_hora_punta.substring(0, lastIndexFin);
            }
        }

        const SelfHelpFarminfo1 = import.meta.glob("../../img/autoayuda/*/autoayuda-pump-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pump-1.png`];
        const SelfHelpFarminfo2 = import.meta.glob("../../img/autoayuda/*/autoayuda-pump-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pump-2.png`];
        const selfHelpParams = {
            header: t("selfHelp.farmInfo.properties"),
            params: [
                t("general.name"),
                `${t("pumpsys.hora_punta")} (${t("pumpsys.inicio_hora_punta")} - ${t("pumpsys.fin_hora_punta")})`
            ],
            definitionName: [
                /* t("pumpsys.alarma_corte"), */
                t("pumpsys.riego_paralelo"),
                `${t("pumpsys.hora_punta")} (${t("pumpsys.inicio_hora_punta")} - ${t("pumpsys.fin_hora_punta")})`
            ],
            definitionText: [
                t("selfHelp.definitions.riegoParalelo"),
                t("selfHelp.definitions.horaPunta")
            ]
        };

        return (
            <div className="card">
                <div className="card-body">
                    <Form id={pump} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-3'>
                                <SelfHelp t={t} params={selfHelpParams} images={[SelfHelpFarminfo1, SelfHelpFarminfo2]} lng={i18n.language} />
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-6 text-center'>
                                <h5 className="card-title"><span>{t("farms.pump.pumpInfo")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-3 d-flex justify-content-end align-items-center'>
                                <HeaderButtons edit={isEdit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={pump} />
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    edit={isEdit}
                                    dato1={data.nombre}
                                    nombre1={isEdit ? `${t("general.name")} *` : t("general.name")}
                                    campo1="nombre"
                                />
                                <FormRow
                                    dato1={t("general.number", { value: data.latitud })}
                                    nombre1={t("node.latitud")}
                                    campo1="latitud"
                                    dato2={t("general.number", { value: data.longitud })}
                                    nombre2={t("node.longitud")}
                                    campo2="longitud"
                                />

                                <FormRow
                                    dato1={hasCorteAlarm ? t("general.answerYes") : t("general.answerNo")}
                                    nombre1={t("pumpsys.alarma_corte")}
                                    campo1="alarma_corte"
                                    dato2={data.riego_paralelo ? t("general.answerYes") : t("general.answerNo")}
                                    nombre2={t("pumpsys.riego_paralelo")}
                                    campo2="riego_paralelo"
                                />

                                <FormRow
                                    edit={isEdit}
                                    dato1={data.habilita_hora_punta ? t("general.answerYes") : t("general.answerNo")}
                                    nombre1={t("pumpsys.hora_punta")}
                                    campo1="habilita_hora_punta"
                                    type1="checkbox"
                                />
                                {(isEdit ? values.habilita_hora_punta : data.habilita_hora_punta) ? <>
                                    <TimeRow
                                        edit={isEdit}
                                        dato={inicio_hora_punta}
                                        nombre={t("pumpsys.inicio_hora_punta")}
                                        campo="inicio_hora_punta"
                                        placeholder={t("pumpsys.inicio_hora_punta")}
                                    />
                                    <TimeRow
                                        edit={isEdit}
                                        dato={fin_hora_punta}
                                        nombre={t("pumpsys.fin_hora_punta")}
                                        campo="fin_hora_punta"
                                        placeholder={t("pumpsys.fin_hora_punta")}
                                    />
                                </> : null}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            nombre: data.nombre,
            inicio_hora_punta: data.inicio_hora_punta && (new Date(`1/1/2020 ${data.inicio_hora_punta}`)),
            fin_hora_punta: data.fin_hora_punta && (new Date(`1/1/2020 ${data.fin_hora_punta}`)),
            habilita_hora_punta: data.habilita_hora_punta
        };
    },
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({ edit: false });
    }
})(withTranslation()(PumpForm));

const customAttributes = { class: "customcss" };

const AlarmsTable = ({ alarmsData, farmId, pumpId, unidades, t, i18n }) => {
    const grid = useRef(null);
    const navigate = useNavigate();

    const numberWithUnits = (tipo_unidad_id, value, unidades) => {
        if (value === undefined || value === null) return "-";
        const localizedValue = t("general.number", { value });
        const unidad = unidades && unidades.find(({ tipo_unidad_id: tui }) => tui === tipo_unidad_id);
        if (!unidad || !unidad.simbolo) return localizedValue;
        return `${localizedValue} ${unidad.simbolo}`;
    };

    const { hidraulicaTemplate,names } = useMemo(() => {
        return {
            hidraulicaTemplate: (_field, { nombre, tipo_hidraulica_id: thi }) => thi && `${switchTipoHidraulica(t, thi)} (${nombre || ""})` || "-",
            names: ["ID", t("farms.hydraulic.hydraulic"), t("pumpsys.alarma"), t("pumpsys.minimo"), t("pumpsys.maximo")],
        };
    }, [t]);

    const templatesDataPointer = useRef({});
    const templateData = templatesDataPointer.current;
    if (templateData.hidraulicaTemplate !== hidraulicaTemplate) templateData.hidraulicaTemplate = hidraulicaTemplate;
    if (templateData.pumpId !== pumpId) templateData.pumpId = pumpId;
    if (templateData.farmId !== farmId) templateData.farmId = farmId;
    if (templateData.navigate !== navigate) templateData.navigate = navigate;


    useColsEffect(grid, names);
    const gridRef = useGridRef(grid, alarmsData);

    const templateRedirectToHydra = (rowData) => {
        const { hidraulica_id } = rowData;
        if (!hidraulica_id) return "-";
        const value = templatesDataPointer.current.hidraulicaTemplate(null, rowData);

        return (
            <a className="pointer" onClick={() => {
                const { farmId, navigate, pumpId } = templatesDataPointer.current;
                pumpId && navigate(
                    { pathname: "/farms/hydraulic", search: `?farm=${farmId}&hydraulic=${hidraulica_id}` },
                    { state: { expanded: ["equipos",`equipo-${pumpId}`,`hidraulicas-${pumpId}`,`hidraulica-${hidraulica_id}`], updateTree: true } }
                );
            }} rel="noopener noreferrer"
            >
                {value}
            </a>
        );
    };
    const alarmaTemplate = (rowData) => {
        const lngs = getBaseLangs(i18n);
        const { tipo_alarma: ta } = rowData;
        return ta && (ta[lngs[0]] || ta[lngs[1]]);
    };
    const minimoTemplate = (rowData, unidades) => {
        const { condicion_minima_activacion: min, tipo_unidad_id, show_condicion } = rowData;
        if(show_condicion){
            return numberWithUnits(tipo_unidad_id, min, unidades);
        }else{
            return "-";
        }
    };

    const maximoTemplate = (rowData, unidades) => {
        const { condicion_maxima_activacion: max, tipo_unidad_id, show_condicion } = rowData;
        if(show_condicion){
            return numberWithUnits(tipo_unidad_id, max, unidades);
        }else{
            return "-";
        }
    };
    if (!Array.isArray(alarmsData)) return null;
    return (<div>
        <DataTablePrime
            t={t}
            items={alarmsData}
            size="small"
            fields={[
                {field:"alarma_hidraulica_id",header:names[0], bodyStyle:{textAlign:"center"}, hidden:true},
                {field:"nombre",header:names[1], body:templateRedirectToHydra, bodyStyle:{textAlign:"center"}},
                {field:"tipo_alarma",header:names[2], body:alarmaTemplate, bodyStyle:{textAlign:"center"}},
                {field:"condicion_minima_activacion",header:names[3], body:((r) => minimoTemplate(r,unidades)), bodyStyle:{textAlign:"center"}},
                {field:"condicion_maxima_activacion",header:names[4], body:((r) => maximoTemplate(r,unidades)), bodyStyle:{textAlign:"center"}},
            ]}
        />
    </div>);
};

const Pump = ({ dataFarm, mapRef }) => {
    const location = useLocation();
    const pumpId = getPump(location);
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [_, dispatch] = useContext(FarmContext);
    const units = dispatch({ type: "get", path: "units" });
    const [info, setInfo] = useState({ data: [], isLoaded: false });
    const canEdit = dispatch({ type: "get", path: "canEdit" });
    const sectors = dispatch({ type: "get", path: "sectors" });
    const sensors = dispatch({ type: "get", path: "sensors" });
    const { psysSectors, psysSectorsIds } = useMemo(() => {
        const ret = { psysSectorsIds: [] };
        const equipo_id = parseInt(pumpId, 10);
        ret.psysSectors = sectors && sectors.filter((s) => {
            const hasEquipo = s && s.equipo && s.equipo.some((id) => id === equipo_id);
            if (hasEquipo) {
                ret.psysSectorsIds.push("" + s.sector_id);
                return true;
            } else return false;
        });
        return ret;
    }, [sectors, pumpId]);

    const hasCorteAlarm = useMemo(() => {
        return Array.isArray(sensors) && sensors.some((s) => s.corte_equipo && s.corte_equipo.includes(pumpId));
    }, [sensors, pumpId]);

    const hasDataSector = dataFarm.mapa_json && dataFarm.mapa_json.sectores && psysSectorsIds.some((id) => {
        const ds = dataFarm.mapa_json.sectores[id];
        return ds && Array.isArray(ds.path) && ds.path.length >= 2;
    });
    const tooltipVisible = (!hasDataSector || !dataFarm.mapa_json.position || !dataFarm.mapa_json.bounds) ? true : false;

    const SelfHelpFarminfo1 = import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-simple-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-farminfo-zonetable-simple-1.png`];
    const SelfHelpFarminfo2 = import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-simple-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-farminfo-zonetable-simple-2.png`];
    const selfHelpParams = {
        header: t("selfHelp.farmInfo.properties"),
        paramsGeneral: [
            t("general.name"),
            t("farms.zone.nombreAlternativo"),
            t("area.area"),
            t("cultivos.especie"),
            t("cultivos.variedad"),
            t("cultivos.subespecie"),
            t("farms.zone.kc"),
        ],
        paramsRiego: [t("farms.zone.caudalTeorico")],
        paramsSuelo: [t("farms.zone.maximo"), `${t("farms.zone.puntoCritico")} 1`, `${t("farms.zone.puntoCritico")} 2`,
            `${t("farms.zone.puntoCritico")} 3`, `${t("farms.zone.puntoCritico")} 4`, t("farms.zone.minimo")],
        paramsClima: [t("farms.zone.calorLimite"), `${t("farms.zone.puntoGestion")} 1`, `${t("farms.zone.puntoGestion")} 2`, t("farms.zone.heladaLimite")],
        definitionName: [
            t("area.area"),
            t("area.calculated"),
            t("farms.zone.kc"),

            t("farms.zone.caudalTeorico"),

            t("farms.zone.maximo"),
            t("selfHelp.definitionsNames.puntosCriticos"),
            t("farms.zone.minimo"),

            t("farms.zone.calorLimite"),
            t("selfHelp.definitionsNames.temperaturas"),
            t("farms.zone.heladaLimite")
        ],
        definitionText: [
            t("selfHelp.definitions.area"),
            t("selfHelp.definitions.estimatedArea"),
            t("selfHelp.definitions.kc"),
            t("selfHelp.definitions.caudalTeorico"),
            t("selfHelp.definitions.maximo"),
            t("selfHelp.definitions.puntosCriticos"),
            t("selfHelp.definitions.minimo"),
            t("selfHelp.definitions.calor"),
            t("selfHelp.definitions.temperaturas"),
            t("selfHelp.definitions.heladas"),

        ]
    };

    useEffect(() => {
        setInfo((state) => {
            return { ...state, isLoaded: false };
        });
        if (pumpId !== null) {
            const param = `/farms/${farmId}/equipo/${pumpId}`;

            const getDatos = async () => {
                RestAPI.get("apiAdminDropControl", param)
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then(([data]) => {
                        if (data) dispatch({ type: "update", path: "pumpsys", params: [{ ...data }], skipReload: true });
                        setInfo({ isLoaded: true, data });
                    })
                    .catch(err => console.error(err));
            };
            getDatos();
        }
    // this runs on initial pumsys-page load, so only depends on the id
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pumpId]);
    const alarmsInfo = info.data && info.data.alarmas;
    const unidades = info.data && info.data.unidades;

    return (
        <div className='row-container'>
            {info.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className="col-xl-6 col-lg-12 col-sm-12" >
                    <FormikForm
                        canEdit={canEdit}
                        farmId={farmId}
                        pumpId={pumpId}
                        data={info.data}
                        hasCorteAlarm={hasCorteAlarm}
                        i18n={i18n}
                        updateData={(newData) => callSend(`/farms/${farmId}/equipo/${pumpId}`, info.data, newData, t, (args) => {
                            setInfo(args);
                            dispatch({ type: "update", path: "pumpsys", params: [args.data] });
                        })}
                    />
                </div>
                <div className="col-xl-6 col-lg-12 col-sm-12 map-col">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center">
                                <span>{t("maps.map")}</span>
                                {tooltipVisible ?
                                    <TooltipPrime id="pump-map-no-data"  content={t("maps.nodata")} >
                                        <FontAwesomeIcon size="1x" icon={faInfoCircle} style={{ color: "tomato" }} />
                                    </TooltipPrime>
                                    : null}
                            </h5>
                            <div className='linea-titulo' />
                            <div className='mapsWrapper'>
                                {dataFarm.mapa_json && dataFarm.mapa_json.position && <GoogleMapsFarm
                                    apiKey="AIzaSyCvs7xPDh2vfmQO2w02lcItOXa6OKOVmQ4"
                                    data={dataFarm.mapa_json}
                                    farmId={dataFarm.campo_id}
                                    filterSectors={psysSectorsIds}
                                    hideNodes
                                    husoHorario={dataFarm.huso_horario}
                                    innerRef={mapRef}
                                    language={i18n.language}
                                    alternateView
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className="col">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' >
                                    <SelfHelp t={t} params={selfHelpParams} images={[SelfHelpFarminfo1, SelfHelpFarminfo2]} lng={i18n.language} zonesTableEditable />
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{`${t("farms.zonesTable.title")} (${(Array.isArray(psysSectors) && psysSectors.length) || 0})`}</span>
                                    </h5>
                                </div>
                                <div id="zonesTableToolbar"
                                    className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                                />
                            </div>
                            <div className='linea-titulo' />
                            {(Array.isArray(psysSectors) && psysSectors.length > 0) ?
                                <ZonesTable dataFarm={dataFarm} dispatch={dispatch} canEdit={canEdit} sectorsInfo={psysSectors} isEquipo t={t} i18n={i18n} units={units} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("pumpsys.alarmas")}</span></h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            {(Array.isArray(alarmsInfo) && alarmsInfo.length > 0) ?
                                <AlarmsTable alarmsData={alarmsInfo} farmId={farmId} pumpId={pumpId} unidades={unidades} t={t} i18n={i18n} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(Pump, "PumpFrag");
